import type { AppThunk } from '@core/core/store'
import type { ProjectId, TabId, WellId } from 'common/types'

import { createCorrelationSchemeOptionsApi, getCorrelationSchemeOptionsApi } from '../../api'
import { correlationSchemeWellsIdsSlice } from './correlationSchemeWellsIdsSlice'

const { addCorrelationSchemeWellsIds } = correlationSchemeWellsIdsSlice.actions

export const getCorrelationSchemeWellsIds =
  ({ projectId, actualTabId }: { projectId: ProjectId; actualTabId: TabId }): AppThunk =>
  dispatch => {
    getCorrelationSchemeOptionsApi(projectId, actualTabId)
      .catch((err: unknown) => {
        console.log(err)
        return []
      })
      .then(orderedWellsIdsList =>
        dispatch(
          addCorrelationSchemeWellsIds({ id: actualTabId, wellsIdsList: orderedWellsIdsList }),
        ),
      )
  }

export const addCorrelationSchemeWells =
  ({
    projectId,
    actualTabId,
    newWellsIdsList,
  }: {
    projectId: ProjectId
    actualTabId: TabId
    newWellsIdsList: WellId[]
  }): AppThunk =>
  dispatch => {
    createCorrelationSchemeOptionsApi(projectId, actualTabId, newWellsIdsList)
      .catch(console.error)
      .then(() =>
        dispatch(addCorrelationSchemeWellsIds({ id: actualTabId, wellsIdsList: newWellsIdsList })),
      )
  }
